export enum TagDeferral {
	Rejected = '2',
	Deferred = '1',
	Pending = '0'
}
